export enum API {
  LOGIN = "/auth/signin/",
  LEAD_GENERATOR_TEMPLATE = "/lead-generator-template/",
  LEAD_GENERATOR = "/lead-generator/",
  POSTBACK = "/postback_event_message/",
  COMMISSION_RULE = "/postback_commission_rule/"
}
